function cache(key: string, def: any = {}) {
  return (
    (window.localStorage.getItem(key) &&
      JSON.parse(window.localStorage.getItem(key) as any)) ||
    def
  );
}

export default {
  quickStart: false,
  quickStartStep: 0,
  quickStartSection: null,
  quickStartHiddenClass: false,
}